import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Injectable({
    providedIn: 'root',
})@Pipe({standalone: true, name: 'secondsToMilliseconds'})

export class SecondsToMillisecondsPipe implements PipeTransform {
    transform(value: number): number {
        return value * 1000;
    }
}
